export const REORDER_STATUS_REQUESTED = "REORDER_STATUS_REQUESTED";
export const REORDER_STATUS_RECEIVED = "REORDER_STATUS_RECEIVED";
export const REORDER_STATUS_REQUEST_FAILED = "REORDER_STATUS_REQUEST_FAILED";

export const REORDER_REQUESTED = "REORDER_REQUESTED";
export const REORDER_REQUEST_RECEIVED = "REORDER_REQUEST_RECEIVED";
export const REORDER_REQUEST_FAILED = "REORDER_REQUEST_FAILED";

export const requestReorderStatus = productCode => ({
  type: REORDER_STATUS_REQUESTED,
  id: productCode
});

export const receiveReorderStatus = (productCode, payload) => ({
  type: REORDER_STATUS_RECEIVED,
  id: productCode,
  payload: payload
});

export const requestReorderReorder = productCode => ({
  type: REORDER_REQUESTED,
  id: productCode
});

export const receiveReorderRequest = (productCode, payload) => ({
  type: REORDER_REQUEST_RECEIVED,
  id: productCode,
  payload: payload
});
